<h1 mat-dialog-title class="text-center text-3xl mb-3">Program Waitlist Notice</h1>

<div mat-dialog-content>

    <div class="sm sm:flex mt-5">
        <h1>{{notice}}</h1>
    </div>

    <div class="sm text-center mt-5 font-semibold">
        <h1>Click or Tap yes to proceed.</h1>
    </div>

</div>

<div class="text-center mt-8">

    <button mat-flat-button=""
        class="mat-focus-indicator ml-3 mat-flat-button mat-button-base mat-warn ng-star-inserted"
        ng-reflect-color="warn" (click)="onCancel(this)">
        <span class="mat-button-wrapper">No</span>
        <span matripple="" class="mat-ripple mat-button-ripple" ng-reflect-disabled="false" ng-reflect-centered="false"
            ng-reflect-trigger="[object HTMLButtonElement]"></span>
        <span class="mat-button-focus-overlay"></span>
    </button>

    <button mat-flat-button="" (click)="onSelect()" class="mat-focus-indicator ml-3 mat-flat-button mat-button-base mat-primary" tabindex="0" ng-reflect-router-link="/add-children"
        ng-reflect-color="primary">
        <span class="mat-button-wrapper">Yes</span><span matripple="" class="mat-ripple mat-button-ripple" ng-reflect-disabled="false" ng-reflect-centered="false"
            ng-reflect-trigger="[object HTMLButtonElement]">
        </span><span class="mat-button-focus-overlay"></span>
    </button>

</div>